function view (path) {
  return () => import(/* webpackChunkName: '' */ '@/views/apa/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

const APARoutes = [
  {
    path: '/apa/dashboard',
    component: view('Dashboard'),
    name: 'apa.dashboard',
    authorizedRole: 'apa'
  },
  // PENDING APPROVALS
  {
    path: '/apa/payments/postings/:apa?/:status?',
    component: view('payments/postings/Base'),
    name: 'apa.payments.postings',
    authorizedRole: 'apa',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Payments'
        },
        {
          text: 'Approvals',
          active: true
        }
      ]
    }
  },
  {
    path: '/apa/payments/:payment/view',
    component: view('payments/postings/PaymentRequest.vue'),
    name: 'apa.payment.viewing',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Payment Posting',
          active: true
        }
      ]
    }
  }
]

export default APARoutes
